import { DEV_DEFAULTS } from '@mtc/shared/environment';

export const environment = {
	clientId: 'muedn9i6638cdkmp3bcshn2s5',
	redirectUri: 'https://dev.tools.mtc.byu.edu/tools/',
	...DEV_DEFAULTS,
};
